(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-in"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.featured-in-section').forEach((root) => {
      const ctaEl = root.querySelector('.js-featured-cta');
      const ctaTitleEl = root.querySelector('.js-featured-cta-title');
      const ctaMediaEl = root.querySelector('.js-featured-cta-media');
      const ctaImgEl = root.querySelector('.js-featured-cta-img');

      const sliderEl = root.querySelector('.featured-in-card__slider');
      if (!sliderEl) return;

      const swiper = new Swiper(sliderEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 600,
        autoHeight: true,
        loop: false,
        pagination: {
          el: root.querySelector('.featured-in-pagination'),
          clickable: true,
          bulletClass: 'swiper-pagination-bullet',
          bulletActiveClass: 'swiper-pagination-bullet-active',
        },
        navigation: {
          nextEl: root.querySelector('.featured-in-next'),
          prevEl: root.querySelector('.featured-in-prev'),
          disabledClass: 'swiper-button-disabled',
        },
      });

      // Update CTA from data attributes on slide change
      swiper.on('slideChange', function () {
        const activeSlide = this.slides[this.activeIndex];
        const dataEl = activeSlide && activeSlide.querySelector('.featured-in-card__body');
        if (!dataEl || !ctaEl) return;

        const link = dataEl.getAttribute('data-product-link');
        const title = dataEl.getAttribute('data-link-title');
        const img = dataEl.getAttribute('data-link-image');

        if (link) ctaEl.setAttribute('href', link);
        if (title && ctaTitleEl) ctaTitleEl.textContent = title;
        if (img && ctaImgEl) {
          // Ensure the browser swaps the image even if the original tag had srcset/sizes
          ctaImgEl.removeAttribute('srcset');
          ctaImgEl.removeAttribute('sizes');
          ctaImgEl.setAttribute('src', img);
          const alt = dataEl.getAttribute('data-link-image-alt') || title || '';
          ctaImgEl.setAttribute('alt', alt);
          if (ctaMediaEl) ctaMediaEl.style.display = '';
        } else if (!img && ctaMediaEl) {
          // Hide media when slide does not provide an image
          ctaMediaEl.style.display = 'none';
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  // Gorgias Chat Toggle Functionality
  let toggleChat = 1;
  const supportButton = document.querySelector('[id^="support-button-footer-"]');

  if (supportButton) {
    supportButton.addEventListener('click', async (event) => {
      event.preventDefault();

      if (toggleChat % 2 == 1) {
        const opened =
          typeof openSupportChat === 'function'
            ? await openSupportChat()
            : typeof GorgiasChat !== 'undefined' && GorgiasChat.open && (GorgiasChat.open(), true);
        if (opened) supportButton.textContent = 'Close Chat';
      } else {
        const closed =
          typeof closeSupportChat === 'function'
            ? await closeSupportChat()
            : typeof GorgiasChat !== 'undefined' && GorgiasChat.close && (GorgiasChat.close(), true);
        if (closed) supportButton.textContent = 'Support';
      }

      toggleChat++;
    });
  }

  const observer = new MutationObserver(function (mutationRecords) {
    for (const mutation of mutationRecords) {
      if (mutation.addedNodes[0] && mutation.addedNodes[0].id === 'gorgias-chat-container') {
        const supportBtn = document.querySelector('[id^="support-button-footer-"]');
        if (supportBtn) {
          supportBtn.textContent = 'Support';
        }
      }
    }
  });

  observer.observe(document.body, { childList: true });

  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucy-collections-2x2"] && !Shopify.designMode) return;
  try {
    
  const POUCHES_SID = "7099121893562";
  const GUM_SID = "7100963684538";
  const LOZENGE_SID = "7321365577914";
  const BREAKERS_SID = "7099088076986";

  const url = `https://api.juniphq.com/v1/products?filter[remote_ids]=${POUCHES_SID},${GUM_SID},${LOZENGE_SID},${BREAKERS_SID}`;

  window.addEventListener('DOMContentLoaded', () => {
    fetch(url, {
      method: "GET",
      headers: { "Junip-Store-Key" : "von5ggVc3op5TN8Z2yo9iiVK" }
    })
    .then(response => response.json()) 
    .then(json => {
      json.products.forEach(product => {
        set(product.remote_handle, JSON.stringify(product), 86400);
        if(document.querySelector(`.${product.remote_handle}`)) {
          document.querySelector(`.${product.remote_handle}.recommended-count`).innerText = `(${product.recommended_count})`;
          document.querySelector(`.${product.remote_handle}.overlay`).style.width = `${(((5 - product.rating_average) / 5) * 100)}%`
        };
      });
    })
    .catch(err => console.log(err));
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucy-discount"] && !Shopify.designMode) return;
  try {
    
const discountCodeBar = document.querySelector('#discount-code');
const announcementBar = document.querySelector('#shopify-section-announcement-bar');

window.addEventListener('DOMContentLoaded', () => {
  const discountCode = getCookie("discount_code");

  if(discountCode === 'barstool') {
    discountCodeBar.classList.remove('xhidden');
    if(window.innerWidth < 780) {
      announcementBar.classList.add('xhidden');
    }
  } else {
    discountCodeBar.classList.add('xhidden');
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucy-home-three-copy"] && !Shopify.designMode) return;
  try {
    
window.addEventListener('DOMContentLoaded', () => {
  // const swiper = new Swiper('.swiper-three-copy', {
  //   // Optional parameters
  //   direction: 'horizontal',
  //   loop: false,
  //   slidesPerView: 1,
  //   spaceBetween: 0,
  //   centeredSlides: true,
  //   pagination: {
  //     el: '.swiper-pagination',
  //     clickable: true
  //   },
  //   navigation: {
  //     nextEl: '.swiper-button-next',
  //     prevEl: '.swiper-button-prev',
  //   },
  // });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucy-homepage-junip"] && !Shopify.designMode) return;
  try {
    
window.addEventListener('DOMContentLoaded', () => {

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucy-reviews"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('DOMContentLoaded', () => {
    // Set testimonial letters
    const testimonialLetters = document.querySelectorAll('.testimonial-letter');
    testimonialLetters.forEach((letter) => {
      const authorName = letter.getAttribute('data-author');
      if (authorName && authorName.length > 0) {
        letter.textContent = authorName.charAt(0).toUpperCase();
      }
    });

    const swiper = new Swiper('.swiper-reviews', {
      direction: 'horizontal',
      initialSlide: 3,
      centeredSlides: true,
      loop: false,
      slidesPerView: 1.2,
      spaceBetween: 20,
      speed: 500,
      breakpoints: {
        990: {
          slidesPerView: 3.5,
          spaceBetween: 20,
        },
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucy-testimonials"] && !Shopify.designMode) return;
  try {
    
window.addEventListener('DOMContentLoaded', () => {
  const swiper = new Swiper('.swiper-testimonials', {
    direction: 'horizontal',
    loop: false,
    slidesPerView: 1,
    spaceBetween: 0,
    breakpoints: {
      990: {
        slidesPerView: 3,
        spaceBetween: 40,
      },
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["made-with-the-best"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var MOBILE_MQ = '(max-width: 989px)';
    var STEP_PX = 400;

    function normalizeFlavor(value) {
      return String(value || '')
        .trim()
        .toLowerCase()
        .replace(/\s+/g, ' ');
    }

    function findFlavorAssets(flavors, flavor) {
      if (!flavors || !flavor) return null;
      if (flavors[flavor] && (flavors[flavor].can || flavors[flavor].pouch)) {
        return { key: flavor, assets: flavors[flavor] };
      }

      var needle = normalizeFlavor(flavor);
      var keys = Object.keys(flavors);
      for (var i = 0; i < keys.length; i++) {
        var assets = flavors[keys[i]];
        if (normalizeFlavor(keys[i]) === needle && assets && (assets.can || assets.pouch)) {
          return { key: keys[i], assets: assets };
        }
      }
      return null;
    }

    function flavorFromVariantId(id) {
      if (!id) return null;
      var map = window.LucyFlavorByVariant || {};
      return map[String(id)] || null;
    }

    function isMobile() {
      return window.matchMedia(MOBILE_MQ).matches;
    }

    try {
      window.sessionStorage.removeItem('lucy:mwtb:finished:' + window.location.pathname);
    } catch (e) {}

    function stageIsActive(img) {
      var stage = img.closest('.made-with-the-best__stage');
      if (!stage) return false;
      return isMobile()
        ? stage.classList.contains('made-with-the-best__stage--mobile')
        : stage.classList.contains('made-with-the-best__stage--desktop');
    }

    function activateSrc(img) {
      var src = img.getAttribute('data-src');
      if (!src || img.getAttribute('src') === src) return;
      var srcset = img.getAttribute('data-srcset');
      var sizes = img.getAttribute('data-sizes');
      if (srcset) img.setAttribute('srcset', srcset);
      if (sizes) img.setAttribute('sizes', sizes);
      img.setAttribute('src', src);
    }

    function MadeWithTheBest(section) {
      this.section = section;
      this.dataEl = document.getElementById('MadeWithTheBestData-' + section.dataset.sectionId);
      if (!this.dataEl) return;

      try {
        this.data = JSON.parse(this.dataEl.textContent);
      } catch (e) {
        return;
      }

      this.currentFlavor = this.data.selectedFlavor || '';
      this.canEls = section.querySelectorAll('[data-mwtb-can], [data-mwtb-can-mobile]');
      this.pouchEls = section.querySelectorAll('[data-mwtb-pouch], [data-mwtb-pouch-mobile]');
      this.canGhost = section.querySelector('[data-mwtb-can-ghost]');
      this.pouchGhost = section.querySelector('[data-mwtb-pouch-ghost]');
      this.mobilePlaceholder = section.querySelector('.made-with-the-best__placeholder--mobile');
      this.hydrated = false;
      this.track = section.querySelector('[data-mwtb-track]');
      this.properties = section.querySelectorAll('.made-with-the-best__property');
      this.steps = parseInt(section.getAttribute('data-mwtb-steps'), 10) || this.properties.length;
      this.currentStep = 0;
      this.complete = false;
      this.ticking = false;
      this.motionMq = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.section.style.setProperty('--mwtb-step-px', STEP_PX + 'px');

      this.syncFromUrl = this.syncFromUrl.bind(this);
      this.onFlavorChange = this.onFlavorChange.bind(this);
      this.onFlavorInput = this.onFlavorInput.bind(this);
      this.hydrateVisible = this.hydrateVisible.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.onPinChange = this.onPinChange.bind(this);

      document.addEventListener('lucy:flavorchange', this.onFlavorChange);
      document.addEventListener('change', this.onFlavorInput);
      window.addEventListener('popstate', this.syncFromUrl);
      window.addEventListener('mwtb:urlchange', this.syncFromUrl);
      window.matchMedia(MOBILE_MQ).addEventListener('change', this.hydrateVisible);
      window.matchMedia(MOBILE_MQ).addEventListener('change', this.onPinChange);
      this.motionMq.addEventListener('change', this.onPinChange);

      this.syncFromUrl();
      this.observe();
      this.bindPin();
    }

    MadeWithTheBest.prototype.canAnimate = function () {
      if (this.steps < 1 || !this.track) return false;
      if (this.motionMq.matches) return false;
      if (window.Shopify && Shopify.designMode) return false;
      return true;
    };

    MadeWithTheBest.prototype.shouldPin = function () {
      if (!this.canAnimate()) return false;
      if (this.complete) return false;
      return true;
    };

    MadeWithTheBest.prototype.bindPin = function () {
      this.onPinChange();
    };

    MadeWithTheBest.prototype.onPinChange = function () {
      if (!this.section.isConnected) {
        this.unbindPin();
        return;
      }

      if (!this.canAnimate()) {
        this.section.classList.add('is-static');
        this.section.classList.remove('is-complete');
        if (this.track) this.track.style.height = '';
        this.setStep(this.steps);
        this.unbindPin();
        return;
      }

      if (this.complete) {
        this.section.classList.remove('is-static');
        this.section.classList.add('is-complete');
        if (this.track) this.track.style.height = '';
        this.setStep(this.steps);
        this.unbindPin();
        return;
      }

      this.section.classList.remove('is-static');
      this.section.classList.remove('is-complete');
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.updateStep();
    };

    MadeWithTheBest.prototype.unbindPin = function () {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    };

    MadeWithTheBest.prototype.onScroll = function () {
      if (this.ticking) return;
      this.ticking = true;
      var self = this;
      requestAnimationFrame(function () {
        self.ticking = false;
        self.updateStep();
      });
    };

    MadeWithTheBest.prototype.releaseLock = function () {
      if (!this.track) {
        this.section.classList.add('is-complete');
        this.unbindPin();
        return;
      }

      this.section.classList.add('is-complete');
      var y = window.scrollY || window.pageYOffset;
      this.track.style.height = '';
      void this.track.offsetHeight;
      var newTop = this.track.getBoundingClientRect().top;
      window.scrollTo(0, y + newTop);
      this.unbindPin();
    };

    MadeWithTheBest.prototype.updateStep = function () {
      if (!this.section.isConnected) {
        this.unbindPin();
        return;
      }
      if (!this.shouldPin()) {
        this.onPinChange();
        return;
      }

      var rect = this.track.getBoundingClientRect();
      var consumed = Math.max(0, -rect.top);
      var step = Math.min(this.steps, Math.floor(consumed / STEP_PX));
      var held = this.currentStep < 0 ? 0 : this.currentStep;
      step = Math.max(held, step);

      this.setStep(step);

      if (step >= this.steps && !this.complete) {
        this.complete = true;
        var self = this;
        window.setTimeout(function () {
          self.releaseLock();
        }, 0);
      }
    };

    MadeWithTheBest.prototype.setStep = function (step) {
      if (step === this.currentStep) return;
      this.currentStep = step;

      this.properties.forEach(function (el, index) {
        var visible = index < step;
        el.classList.toggle('is-visible', visible);
        el.setAttribute('aria-hidden', visible ? 'false' : 'true');
      });
    };

    MadeWithTheBest.prototype.observe = function () {
      var self = this;
      var idle =
        window.requestIdleCallback ||
        function (cb) {
          return setTimeout(cb, 1);
        };

      function onIdleHydrate() {
        idle(self.hydrateVisible, { timeout: 3000 });
      }

      if (document.readyState === 'complete') {
        onIdleHydrate();
      } else {
        window.addEventListener('load', onIdleHydrate, { once: true });
      }

      if (!('IntersectionObserver' in window)) {
        this.section.classList.add('is-inview');
        return;
      }

      var io = new IntersectionObserver(
        function (entries) {
          if (
            !entries.some(function (entry) {
              return entry.isIntersecting;
            })
          )
            return;
          self.section.classList.add('is-inview');
          self.hydrateVisible();
          io.disconnect();
        },
        { rootMargin: '200px 0px' }
      );
      io.observe(this.section);
    };

    MadeWithTheBest.prototype.hydrateVisible = function () {
      this.hydrated = true;
      this.pouchEls.forEach(function (img) {
        if (stageIsActive(img)) activateSrc(img);
      });
      this.canEls.forEach(function (img) {
        if (stageIsActive(img)) activateSrc(img);
      });
    };

    MadeWithTheBest.prototype.onFlavorInput = function (event) {
      var input = event.target;
      if (!input || input.type !== 'radio' || !input.value) return;
      if (normalizeFlavor(input.name) !== 'flavor') return;
      this.setFlavor(input.value);
    };

    MadeWithTheBest.prototype.onFlavorChange = function (event) {
      var flavor = event && event.detail && event.detail.flavor;
      if (!flavor) return;
      this.setFlavor(flavor);
    };

    MadeWithTheBest.prototype.syncFromUrl = function () {
      var id = new URLSearchParams(window.location.search).get('variant');
      var flavor = flavorFromVariantId(id);
      if (flavor) this.setFlavor(flavor);
    };

    MadeWithTheBest.prototype.setFlavor = function (flavor) {
      if (!flavor || normalizeFlavor(flavor) === normalizeFlavor(this.currentFlavor)) return;

      var match = findFlavorAssets(this.data.flavors, flavor);
      if (!match) return;

      var assets = match.assets;
      this.currentFlavor = match.key;
      this.section.dataset.selectedFlavor = match.key;
      this.section.classList.add('is-swapping');

      var self = this;
      this.pouchEls.forEach(function (img) {
        self.applyImage(img, assets.pouch, match.key + ' pouch');
      });
      this.canEls.forEach(function (img) {
        self.applyImage(img, assets.can, match.key + ' can');
      });

      if (this.pouchGhost) this.pouchGhost.hidden = Boolean(assets.pouch);
      if (this.canGhost) this.canGhost.hidden = Boolean(assets.can);
      if (this.mobilePlaceholder) this.mobilePlaceholder.hidden = Boolean(assets.can || assets.pouch);

      window.setTimeout(function () {
        self.section.classList.remove('is-swapping');
      }, 180);
    };

    MadeWithTheBest.prototype.applyImage = function (img, src, alt) {
      if (!img) return;
      if (!src) {
        img.hidden = true;
        img.removeAttribute('src');
        img.removeAttribute('srcset');
        img.removeAttribute('data-src');
        img.removeAttribute('data-srcset');
        return;
      }
      img.hidden = false;
      img.setAttribute('data-src', src);
      img.removeAttribute('srcset');
      img.removeAttribute('data-srcset');
      img.alt = alt;
      if (this.hydrated && stageIsActive(img)) {
        img.src = src;
      } else {
        img.removeAttribute('src');
      }
    };

    function initMadeWithTheBest() {
      document.querySelectorAll('.made-with-the-best[data-section-id]').forEach(function (section) {
        if (section.dataset.mwtbReady) return;
        section.dataset.mwtbReady = 'true';
        section.__mwtb = new MadeWithTheBest(section);
      });
    }

    if (!window.__mwtbHistoryPatched) {
      window.__mwtbHistoryPatched = true;
      ['pushState', 'replaceState'].forEach(function (method) {
        var original = history[method];
        history[method] = function () {
          var result = original.apply(this, arguments);
          window.dispatchEvent(new Event('mwtb:urlchange'));
          return result;
        };
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initMadeWithTheBest);
    } else {
      initMadeWithTheBest();
    }

    document.addEventListener('shopify:section:load', initMadeWithTheBest);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  function getCart() {
    fetch(`${routes.cart_url}.js`)
      .then((response) => response.json())
      .then((data) => {
        // iterateSellingPlans(data);
        buildCartFooter(data);
      })
      .catch((error) => {
        //handle error
        console.log(error);
      });
  }

  getCart();

  document.addEventListener('update-main-footer', (e) => {
    buildCartFooter(e.detail.parsedState);
  });

  function iterateSellingPlans(data) {
    data.items.map((item) => {
      console.log(item);
      console.log(item.title + ' ' + (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan.id));
    });
  }

  function buildCartFooter(data) {
    if (data.item_count == 0) return;

    const CPP = new CartPackageProtection();
    const CA = new CartAddons();
    CPP.buildPackageProtectionWidget(data);
    CA.buildCartAddonsWidget(data);
  }

  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  class CartPackageProtection extends HTMLElement {
    constructor() {
      super();
    }

    buildPackageProtectionWidget(data) {
      const PACKAGE_PROTECTION_VID = 41435314159802;
      const SELLING_PLAN_ID = 711590074;
      const checkbox = document.getElementById('checkbox-package-protection');

      const cartHasAProductSubscription = data.items.some(
        (cart_item) => cart_item.id !== PACKAGE_PROTECTION_VID && 'selling_plan_allocation' in cart_item
      );
      const cartHasPackageProtection = data.items.some((cart_item) => cart_item.id == PACKAGE_PROTECTION_VID);
      const cartHasPackageProtectionSubscription = data.items.some(
        (cart_item) => cart_item.id == PACKAGE_PROTECTION_VID && 'selling_plan_allocation' in cart_item
      );
      const cartHasOnlyPackageProtection = data.items.every((cart_item) => cart_item.id == PACKAGE_PROTECTION_VID);
      const body = cartHasAProductSubscription
        ? { id: PACKAGE_PROTECTION_VID, quantity: 1, selling_plan: SELLING_PLAN_ID }
        : { id: PACKAGE_PROTECTION_VID, quantity: 1 };

      // Customer adds or removes package protection
      checkbox.addEventListener('click', function () {
        document.querySelector('.totals__subtotal-value').classList.add('xhidden');
        document.querySelector('#subtotal__spinner').classList.remove('hidden');

        if (checkbox.checked) {
          fetch(`${routes.cart_add_url}`, {
            body: JSON.stringify(body),
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            method: 'POST',
          }).then((response) => {
            fetch(`${routes.cart_url}.js`)
              .then((response) => response.json())
              .then((data) => {
                const { original_total_price: new_price } = data;
                document.querySelector('.totals__subtotal-value').innerText = `$${new_price / 100} USD`;
                document.querySelector('.totals__subtotal-value').classList.remove('xhidden');
                document.querySelector('#subtotal__spinner').classList.add('hidden');
                document.getElementById('icon-unlock').classList.add('xhidden');
                document.getElementById('icon-unlock').classList.remove('xblock');
                document.getElementById('icon-lock').classList.remove('xhidden');
                document.getElementById('icon-lock').classList.add('xblock');
              })
              .catch((error) => {
                //handle error
                console.log(error);
              });
          });
        } else {
          fetch(`${routes.cart_update_url}`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              updates: {
                41435314159802: 0,
              },
            }),
          }).then((response) => {
            fetch(`${routes.cart_url}.js`)
              .then((response) => response.json())
              .then((data) => {
                const { original_total_price: new_price } = data;
                document.querySelector('.totals__subtotal-value').innerText = `$${new_price / 100} USD`;
                document.querySelector('.totals__subtotal-value').classList.remove('xhidden');
                document.querySelector('#subtotal__spinner').classList.add('hidden');
                document.getElementById('icon-unlock').classList.add('xblock');
                document.getElementById('icon-unlock').classList.remove('xhidden');
                document.getElementById('icon-lock').classList.remove('xblock');
                document.getElementById('icon-lock').classList.add('xhidden');
              })
              .catch((error) => {
                //handle error
                console.log(error);
              });
          });
        }
      });

      // Start with package protection
      if (cartHasPackageProtection) {
        const line_item = data.items.findIndex((cart_item) => cart_item.id === PACKAGE_PROTECTION_VID) + 1;
        checkbox.checked = true;

        if (cartHasAProductSubscription && !cartHasPackageProtectionSubscription) {
          this.swapPackageProtection({
            line: line_item,
            quantity: 1,
            selling_plan: SELLING_PLAN_ID,
          });
        } else if (!cartHasAProductSubscription && cartHasPackageProtectionSubscription) {
          this.swapPackageProtection({
            line: line_item,
            quantity: 1,
            selling_plan: null,
          });
        }
      } else {
        checkbox.checked = false;
        document.getElementById('icon-unlock').classList.add('xblock');
        document.getElementById('icon-unlock').classList.remove('xhidden');
        document.getElementById('icon-lock').classList.remove('xblock');
        document.getElementById('icon-lock').classList.add('xhidden');
      }

      // Disable checkout button and clear cart if only has a package protection
      if (cartHasOnlyPackageProtection) {
        document.querySelector('#checkout').disabled = true;
        this.clearCart();
      }

      // if(!sessionStorage.getItem('packageProtectionAddedFirstTime') && !cartHasPackageProtection) {
      //   sessionStorage.setItem('packageProtectionAddedFirstTime', true);
      //   this.addPackageProtection(body);
      // }
    }

    clearCart() {
      fetch('/cart/clear', {
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        method: 'POST',
      }).finally((e) => {
        window.location.reload();
      });
    }

    swapPackageProtection(_body) {
      fetch('/cart/change.js', {
        body: JSON.stringify(_body),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        method: 'POST',
      }).finally((e) => {
        window.location.reload();
      });
    }
  }

  class CartAddons extends HTMLElement {
    constructor() {
      super();
    }

    checkStrengthValue(array, values) {
      for (let item of array) {
        for (let option of item.options_with_values) {
          if (option.name === 'Strength' && values.includes(option.value)) {
            return true;
          }
        }
      }
      return false;
    }

    containsLozengeHandle(products) {
      return products.some((product) => {
        return product.handle === 'lozenge' || product.handle === 'lozenge-variety';
      });
    }

    containsSaleHandle(products) {
      return products.some((product) => product.handle === 'sale');
    }

    onlyContainsSaleHandle(products) {
      return products.every((product) => product.handle === 'sale');
    }

    getProductHandles(products) {
      return products.map((product) => product.variant_options[0] + ' ' + product.product_title);
    }

    buildCartAddonsWidget(data) {
      const businessRules = {
        '2mg Gum': ['LG9X2MGMTUS', 'LB6X4MGMTUS'],
        '4mg Gum': ['LG9X4MGMGUS', 'LG9X4MGV2US'],
        '6mg Gum': ['LB6X8MGESUS', 'LB6X4MGMTUS'],
        '4mg Breakers': ['LG9X4MGBCUS', 'LG9X4MGV2US'],
        '8mg Breakers': ['LB6X8MGESUS'],
        '4mg Pouches': ['LG9X4MGBCUS', 'LG9X4MGV2US'],
        '8mg Pouches': ['LB6X8MGESUS'],
        '12mg Pouches': ['LB6X8MGESUS'],
        '4mg Lozenges': ['LG9X4MGBCUS'],
      };

      const cart_items = data.items;
      const cartHasSaleItem = this.containsSaleHandle(cart_items);
      const productHandles = this.getProductHandles(cart_items);
      const cartOnlyHasSaleItem = this.onlyContainsSaleHandle(cart_items);
      const cartAddons = document.getElementsByClassName('cart-add-ons__item');

      // Hide items every time
      for (let i = 0; i < cartAddons.length; i++) {
        cartAddons[i].classList.add('xhidden');
      }

      // Hide the add-ons if cart has sale item
      if (cartHasSaleItem) {
        document.getElementById('cart-add-ons').classList.add('xhidden');
      }

      const offeringSKUs = businessRules[productHandles[0]];
      if (offeringSKUs) {
        offeringSKUs.forEach((sku) => {
          const element = document.getElementById(sku);
          if (element) {
            element.classList.remove('xhidden');
          }
        });
      }

      if (cartOnlyHasSaleItem) {
        document.getElementById('checkout').classList.remove('xbg-teal');
        document.getElementById('checkout').classList.add('xbg-gray-500');
        document.getElementById('checkout').disabled = true;
      }
    }
  }

  class CartPackagingNote extends HTMLElement {
    constructor() {
      super();
    }
  }

  customElements.define('cart-package-protection', CartPackageProtection);
  customElements.define('cart-note', CartNote);
  customElements.define('cart-add-ons', CartAddons);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  const selling_plan_gum = 711655610;
  const selling_plan_breakers = 711622842;
  const selling_plan_pouches = 711688378;
  const selling_plan_lozenge = 1302921402;

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.button-subscribe-save').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();

        this.innerText = 'Upgrading...';
        this.classList.add('xanimate-pulse');

        const key = this.dataset.key;
        const productType = this.dataset.productType;
        let selling_plan;

        switch (productType.toLowerCase()) {
          case 'gum':
            selling_plan = selling_plan_gum;
            break;
          case 'pouches':
            selling_plan = selling_plan_pouches;
            break;
          case 'breakers':
            selling_plan = selling_plan_breakers;
            break;
          case 'lozenge':
            selling_plan = selling_plan_lozenge;
            break;
          default:
            break;
        }

        const body = { id: key, selling_plan: selling_plan };

        fetch(`${routes.cart_change_url}`, {
          body: JSON.stringify(body),
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          method: 'POST',
        }).then((response) => {
          fetch(`${routes.cart_url}.js`)
            .then((response) => response.json())
            .then((data) => {
              window.location.reload();
            })
            .catch((error) => {
              //handle error
              console.log(error);
            });
        });
      });
    });

    document.querySelectorAll('.select-change-plan').forEach(function (select) {
      select.addEventListener('change', function (event) {
        event.preventDefault();

        const selectedOption = select.options[select.selectedIndex];
        selectedOption.text = 'Downgrading...';

        const key = this.dataset.key;
        const body = { id: key, selling_plan: null };

        fetch(`${routes.cart_change_url}`, {
          body: JSON.stringify(body),
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          method: 'POST',
        }).then((response) => {
          fetch(`${routes.cart_url}.js`)
            .then((response) => response.json())
            .then((data) => {
              window.location.reload();
            })
            .catch((error) => {
              //handle error
              console.log(error);
            });
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["redirect-product"]) return;
  try {
    
  switch (window.location.pathname) {
    case '/products/chewpark':
      window.location.href = '/products/gum';
      break;
    case '/products/slim-pouches':
      window.location.href = '/products/pouches';
      break;
    case '/products/kapsel-pouches':
      window.location.href = '/products/breakers';
      break;
    case '/products/nicotinelozenge':
      window.location.href = '/products/lozenge';
      break;
    case '/products/nicotinelozengeold':
      window.location.href = '/products/lozenge';
      break;
    case '/products/insurance-protection':
      window.location.href = '/';
      break;
  }

  } catch(e) { console.error(e); }
})();
})();
